module.exports = __webpack_public_path__ + "img/plan_icon.a99a48d6.svg";